export default "__VITE_ASSET__B$Zvqnsz__"